import React, { useEffect, useState } from "react";
import axios from "axios";
import { CircularProgress, Typography, Box } from "@mui/material";
import { useNavigate } from "react-router-dom";
import { ssoLoginUser } from "../apis/apiList/userApi"; // Adjust the import path as necessary
import { useApp } from "../context/AppContext";
import { useMessage } from "../context/MessageContext";

const SSOLoginPage = () => {
  const navigate = useNavigate();
  const [status, setStatus] = useState("loading");
  const [errorMsg, setErrorMsg] = useState("");
  const { login } = useApp();
  const { showMessage } = useMessage();

  useEffect(() => {
    const runSSOLogin = async () => {
      const queryParams = new URLSearchParams(window.location.search);
      const token = queryParams.get("token");

      if (!token) {
        setStatus("error");
        setErrorMsg("Missing token in URL.");
        return;
      }

      try {
        
        const response = await ssoLoginUser(token);

        console.log("SSO Login response:", response);

        if (response.success) {
          login(response.user);
          if(response.user.role == 'admin'){
            // navigate("/profile");
            // navigate("/task/list");
            navigate(`/org/${response?.project?.orgId}/project/view/${response?.project?._id}`);
          } else {
            navigate(`/subs/org/${response?.project?.orgId}/project/view/${response?.project?._id}`);
          }
          showMessage("logged in successfully", "success");
        }
        // Redirect to dashboard after successful login
        // navigate("/profile");
      } catch (error) {
        console.error("SSO login failed", error);
        setStatus("error");
        setErrorMsg(
          error.response?.data || "VPMA Login failed. Please try again."
        );
      }
    };

    runSSOLogin();
  }, [navigate]);

  if (status === "loading") {
    return (
      <Box
        display="flex"
        alignItems="center"
        justifyContent="center"
        minHeight="100vh"
        flexDirection="column"
      >
        <CircularProgress />
        <Typography mt={2}>Logging you in via VPMA...</Typography>
      </Box>
    );
  }

  return (
    <Box
      display="flex"
      alignItems="center"
      justifyContent="center"
      minHeight="100vh"
      flexDirection="column"
    >
      <Typography variant="h6" color="error" gutterBottom>
        Login Failed
      </Typography>
      <Typography>{errorMsg}</Typography>
    </Box>
  );
};

export default SSOLoginPage;
